import {AxiosRequestConfig} from "axios";
import Components from "slotworks/components/components";
import IntroPopup from "slotworks/components/promo-popups/intro-popup";
import Prompt from "slotworks/components/prompt/prompt-content";
import CanvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import Translations from "slotworks/i18n/translations";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import GameState from "slotworks/model/game-state";
import SettingsModel from "slotworks/model/settings/settings-model";
import SlotDefinition from "slotworks/model/slot-definition";
import CommsManager from "slotworks/server/comms-manager";
import SmartButton, {SmartButtonFlag} from "slotworks/smart-button/smart-button";
import BaseInit from "slotworks/state-machine/standard/states/init";
import Contract from "slotworks/utils/contract";
import DeviceInfo from "slotworks/utils/device-info";
import Point from "slotworks/utils/geom/point";
import {parallel, sequence} from "slotworks/utils/race-utils";
import {showPFSIntro} from "../../../commands/promo-free-spins/show-pfs-intro";
import Regulation from "slotworks/integration/revolver/regulations/regulation";

declare const __VERSION__: string;

export default class RevolverInit extends BaseInit {

    protected portraitScale: number = 1;
    protected gameAnchor: Point = new Point(0.5, 0);

    public complete() {
        Components.betMenu.onVisibleChange.add((visible: boolean) => {
            if (visible) {
                if (Layers.Header.hasScene("freespins")) {
                    Layers.Header.setScene("freespins").execute();
                }
            } else {
                Layers.Header.defaultScene().execute();
            }
        });

        if (DeviceInfo.layoutMain.includes("mobile")) {
            Components.betMenu.onVisibleChange.add((visible: boolean) => {
                if (visible) {
                    Layers.BetBar.hide();
                    Layers.SmartButton.hide();
                    Layers.Header.hide();
                } else {
                    Layers.BetBar.show();
                    Layers.SmartButton.show();
                    Layers.Header.show();
                }
            });
        }

        Layers.MatrixBackground.onSceneEnter.add(() => {
            this.updateTabText();
        });

        this.updateTabText();

        Layers.MenusContent.onSceneEnter.add(() => {
            const rulesText = Layers.MenusContent.getFlexiText("rules_body");

            if (rulesText) {
                rulesText.setText(Translations.get("rm.bod", { version: __VERSION__ }));
            }
        });

        parallel([() => this.initialOpenRequest(), () => this.showGameIntro()]).then(() => {
            this.showGame().then(() => super.complete());
        });
    }

    public onExit() {
        CanvasManager.setPortraitScale(this.portraitScale, this.gameAnchor);

        super.onExit();
    }

    protected startGame() {
        Layers.hideAll();
        Layers.Background.show();
        Layers.Prompts.show();
        Layers.Menus.show();

        super.startGame();

        Components.banner.stop();
    }

    protected showGameIntro() {
        if (SettingsModel.getShowIntro()) {

            const gameIntro = new Prompt(["gameintro"]);
            const toggleHandler = (value: any) => {
                SettingsModel.setShowIntro(!value);
            };

            gameIntro.addContinueButton();
            gameIntro.addToggle("show", toggleHandler);

            CanvasManager.setPortraitScale(this.portraitScale, new Point(0.5, 0.5));

            if (Layers.Background.hasScene("gameintro")) {
                return sequence([
                                    () => Layers.Background.setScene("gameintro"),
                                    () => parallel([() => Components.prompt.showPrompt(gameIntro),
                                                    () => Components.soundIntro.show(gameIntro)]),
                                    () => Layers.Background.defaultScene()
                                ]);
            } else {
                return parallel([() => Components.prompt.showPrompt(gameIntro),
                                 () => Components.soundIntro.show(gameIntro)]);
            }
        } else {
            return Contract.empty();
        }
    }

    private updateTabText() {
        const left = Layers.MatrixBackground.getText("lines_left");
        const right = Layers.MatrixBackground.getText("lines_right");

        if (left) {
            left.text = Translations.get("tab.lin", { lines: SlotDefinition.maxLines });
        }
        if (right) {
            right.text = Translations.get("tab.lin", { lines: SlotDefinition.maxLines });
        }
    }

    private initialOpenRequest() {
        const openRequest = {
            method: "post",
            url: RevolverModel.getBaseURL(),
            withCredentials: true,
            data: JSON.stringify({
                                     cmd: "OPEN",
                                     session: RevolverModel.session
                                 })
        } as AxiosRequestConfig;

        if (RevolverModel.jwt_token) {
            openRequest.headers = {
                "X-RGS-SESSION-TOKEN": RevolverModel.jwt_token
            };
        }

        return CommsManager.requestRaw(openRequest);
    }

    private showGame() {
        return new Contract((resolve) => {
            Layers.showAll();

            Components.banner.start();

            SettingsModel.setDisplayCoins(false);

            Layers.PromoBetBar.hide();
                        
            Components.soundIntro.show().then(() => { 
                if (CampaignsModel.isFreespinsActive()) {
                    Components.createPromoComponents();
    
                    if (!GameState.getCurrentGame().isRecovered) {
                        showPFSIntro();
                    }
                }

                Regulation.gameReady();
                resolve(null) 
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/states/revolver-init.ts